<template>
  <va-card>
    <va-data-table
      :fields="fields"
      :data="Suppliers"
      :rowClass="() => 'suppliersTable'"
      @row-clicked="editSupplier"
    ></va-data-table>
    <!-- :totalPages="totalPages" -->
    <!-- :per-page="parseInt(filter.limit)" -->
    <!-- :loading="loading" -->
    <!-- @page-selected="readPage" -->
    <!--  -->
    <va-button class="add-button" @click="showLargeModal = true">
      {{ $t('suppliers.list.addButton') }}
    </va-button>

    <va-modal
      v-model="showLargeModal"
      class="modal"
      size="large"
      :noOutsideDismiss="true"
      @ok="addSupplier"
      @cancel="cacheSupplierClear"
    >
      <!-- @cancel="canncelModal"
      @ok="okModal" -->

      <va-input
        v-model="cachesupplier.name"
        :placeholder="$t('suppliers.name')"
      />
      <va-input
        v-model="cachesupplier.base_url"
        :placeholder="$t('suppliers.base_url')"
      />
      <va-input
        v-model="cachesupplier.API_key"
        :placeholder="$t('suppliers.API_key')"
      />
      <!-- <va-color-picker-input mode="advanced" v-model="cachesupplier.color">
        <va-color-square :value="cachesupplier.color" />
      </va-color-picker-input>
      <va-toggle class="is_enabled" v-model="cachesupplier.is_enabled" small />  -->
      <!-- @input="cachesupplier.is_enabled" -->
      <!-- <va-button
        class="is_enabled"
        v-if="!cachesupplier.is_enabled"
        @click="removeSource(cachesupplier.id)"
        flat
        small
      >
        {{ $t('tables.delete') }}
      </va-button> -->
    </va-modal>
  </va-card>
</template>
<script>
export default {
  data () {
    return {
      isEdit: false,
      showLargeModal: false,
      cachesupplier: {
        id: '',
        API_key: '',
        balance: '',
        base_url: '',
        name: '',
      },
    }
  },
  methods: {
    async addSupplier () {
      if (this.isEdit) {
        await this.$store.dispatch('updateSupplier', this.cachesupplier)
      } else {
        await this.$store.dispatch('addSupplier', this.cachesupplier)
      }
      await this.cacheSupplierClear()
    },
    cacheSupplierClear () {
      for (const key in this.cachesupplier) {
        this.cachesupplier[key] = ''
      }
      this.isEdit = false
    },
    cacheSupplierSet (obj) {
      for (const key in obj) {
        if (Object.hasOwnProperty.call(obj, key)) {
          this.cachesupplier[key] = obj[key]
        }
      }
    },
    editSupplier (Supplier) {
      this.cacheSupplierSet(Supplier)
      this.showLargeModal = true
      this.isEdit = true
    },
  },
  computed: {
    Suppliers () {
      return this.$store.getters.dataSuppliers
    },
    fields () {
      return [
        {
          name: 'id',
          title: this.$t('suppliers.id'),
        },
        {
          name: 'name',
          title: this.$t('suppliers.name'),
        },
        {
          name: 'base_url',
          title: this.$t('suppliers.base_url'),
        },
        {
          name: 'API_key',
          title: this.$t('suppliers.API_key'),
        },
        {
          name: 'balance',
          title: this.$t('suppliers.balance'),
        },
        {
          name: 'currency',
          title: this.$t('suppliers.currency'),
        },
      ]
    },
  },
  created () {
    this.$store.dispatch('getAllSuppliers')
  },
}
</script>
<style lang="scss">
.modal {
  .va-modal {
    min-width: 50%;
  }
}

.suppliersTable {
  cursor: pointer;
}
</style>
